import React from "react";
import { StarIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { testimonials } from "../data/landing";
export function Testimonials() {
  return <section className="bg-white px-5 py-16 text-navy-900 sm:py-20" data-id="element-292" data-mp="3fzntrlbxjb1d">
      <div className="mx-auto max-w-5xl" data-id="element-293" data-mp="3fxuooagysyvh">
        <div className="mx-auto max-w-2xl text-center" data-id="element-294" data-mp="3b147fjtfbx8h">
          <h2 className="font-display text-3xl font-black leading-tight sm:text-4xl" data-id="element-295" data-mp="3b0az4eetgzo8">What Other Dental Professionals Think</h2>
          <p className="mt-4 text-base leading-relaxed text-navy-700" data-id="element-296" data-mp="31zwab52n92fz">
            The most useful professional resources are those that help you organize information and find what you need without unnecessary complexity.
          </p>
        </div>
        <ul className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-297" data-mp="2s307nfzffajc">
          {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-3xl bg-cream p-6" data-id="element-298" data-mp="v85a7yk6bf3b">
              <div className="flex gap-0.5 text-gold-500" aria-label="5 out of 5 stars" data-id="element-299" data-mp="qa3mv1fpstm1">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-current" aria-hidden="true" data-id="element-300" data-mp="h8aytf4m6trr" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 flex-1 text-lg leading-relaxed text-navy-800" data-id="element-301" data-mp="780n5yy89uep">“{t.quote}”</blockquote>
              <div className="mt-5 flex items-center gap-4 border-t border-navy-900/10 pt-5" data-id="element-302" data-mp="c622q9wg3blf">
                <img src={t.image} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-2 ring-gold-400" loading="lazy" data-id="element-303" data-mp="zvwgqusi3679" />
                <div data-id="element-304" data-mp="14ur7ciwplz1x">
                  <p className="font-bold" data-id="element-305" data-mp="14xdckbw4o2gz">{t.name}</p>
                  <p className="text-sm text-navy-700" data-id="element-306" data-mp="q5v18re7qw3y">{t.role} · {t.location}</p>
                </div>
              </div>
            </li>)}
        </ul>
        <div className="mt-10" data-id="element-307" data-mp="1ivk2n5uu4y63">
          <CTAButton label="Join These Professionals — Get Access" data-id="element-308" data-mp="1iu8xp2pnlkde" />
        </div>
      </div>
    </section>;
}